import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";

// import rice from "../../public/assets/rice.jpg";

const productData = [
  {
    title: "Rice",
    // description:
    //   "This is a description of product 1. It is a great product used by many customers.",
    imageUrl: "/assets/rice.jpg",
  },
  {
    title: "Cereals",
    // description:
    //   "This is a description of product 2. Customers love this product for its quality.",
    imageUrl: "/assets/Cereals.jpg", // Replace with actual product image URL
  },
  {
    title: "Grains",
    // description:
    //   "This is a description of product 3. It is popular among our customers for its design.",
    imageUrl: "/assets/grains.jpg", // Replace with actual product image URL
  },
  {
    title: "Flour",
    // description:
    //   "Product 4 is known for its durability and high performance. A favorite choice for professionals.",
    imageUrl: "/assets/flour.jpg", // Replace with actual product image URL
  },
  {
    title: "Pulses",
    // description:
    //   "This is product 5, a revolutionary gadget that has become a top seller in the market.",
    imageUrl: "/assets/pulses.jpg", // Replace with actual product image URL
  },
  {
    title: "Sugar",
    // description:
    //   "Product 6 offers excellent value for money and is highly rated by our customers.",
    imageUrl: "/assets/sugar.jpg", // Replace with actual product image URL
  },
  {
    title: "Jaggery",
    // description:
    //   "Product 7 is perfect for those who appreciate sleek design and cutting-edge technology.",
    imageUrl:
      "https://media.istockphoto.com/id/1409914597/photo/closeup-of-indian-palm-jaggery-in-a-wooden-ladle-isolated-on-palm-leaf-in-horizontal.webp?a=1&b=1&s=612x612&w=0&k=20&c=JQkE6hO3gIqByF9Ic_1nWppR5y1vOb7V9Z5u38Ekvq8=", // Replace with actual product image URL
  },
  {
    title: "Whole Spice",
    // description:
    //   "An innovative product that has gained popularity for its unique features and ease of use.",
    imageUrl: "/assets/spice.jpg", // Replace with actual product image URL
  },
  {
    title: "Ground Spices",
    // description:
    //   "Product 9 is a customer favorite, praised for its stylish design and high performance.",
    imageUrl: "/assets/ground-spices.jpg", // Replace with actual product image URL
  },
  {
    title: "Oils",
    // description:
    //   "Product 9 is a customer favorite, praised for its stylish design and high performance.",
    imageUrl: "/assets/Oils.jpg", // Replace with actual product image URL
  },
  {
    title: "Honey",
    // description:
    //   "Product 9 is a customer favorite, praised for its stylish design and high performance.",
    imageUrl:
      "https://media.istockphoto.com/id/2161304146/photo/natural-organic-honey-in-glass-jar-honey-dipper-and-honeycombs-are-near-natural-food.webp?a=1&b=1&s=612x612&w=0&k=20&c=8i8HlLRsrgKhoc7Nx63pXNbKzpV6EtdDz8ZPLAYb_5c=", // Replace with actual product image URL
  },
  {
    title: "Superfood",
    // description:
    //   "Product 9 is a customer favorite, praised for its stylish design and high performance.",
    imageUrl:
      "https://media.istockphoto.com/id/1469228227/photo/fresh-salad-of-lentils-spinach-and-almonds.webp?a=1&b=1&s=612x612&w=0&k=20&c=m1Nw_c4nG2O3eB0nEZIJ2DuYbTfAj_1PibB75_sImZw=", // Replace with actual product image URL
  },
  {
    title: "Dry Fruits",
    // description:
    //   "Product 9 is a customer favorite, praised for its stylish design and high performance.",
    imageUrl:
      "https://media.istockphoto.com/id/1218693828/photo/wooden-bowl-with-mixed-nuts-on-rustic-table-top-view-healthy-food-and-snack.webp?a=1&b=1&s=612x612&w=0&k=20&c=un8-1rnSbeydD36u6g5Jp4MLrzX2GWOGYuxZJeYQrXU=", // Replace with actual product image URL
  },
  {
    title: "Packaged Food ",
    // description:
    //   "Product 9 is a customer favorite, praised for its stylish design and high performance.",
    imageUrl:
      "https://media.istockphoto.com/id/157636527/photo/variety-of-fresh-canned-amp-packaged-foods-isolated-on-white.webp?a=1&b=1&s=612x612&w=0&k=20&c=bEfzNgZSbGDm7g9gK_qVd3MWOrS5wc7IdggONjJcxPY=", // Replace with actual product image URL
  },
];

const productFruitsData = [
  {
    title: "Blueberries",
    imageUrl: "/assets/blueberries.jpg",
  },
  {
    title: "Apples",
    imageUrl: "/assets/apple.jpg",
  },
  {
    title: "Dragon Fruits",
    imageUrl: "/assets/dragon-fruit.jpg",
  },
  {
    title: "Cherry",
    imageUrl: "/assets/cherry.jpg",
  },
  {
    title: "Kiwi",
    imageUrl:
      "https://media.istockphoto.com/id/1197398838/photo/bowl-of-dried-kiwi-fruits.webp?a=1&b=1&s=612x612&w=0&k=20&c=56Gc_aJQagifU7brpI84uW7x_RujFl-3xvAtZkAF3NI=",
  },
  {
    title: "Avocado",
    imageUrl: "/assets/avocado.jpg",
  },
  {
    title: "Oranges",
    imageUrl: "/assets/oranges.jpg",
  },
  {
    title: "Plum",
    imageUrl: "/assets/plum.jpg",
  },
];

const ProductOfCustomers = () => {
  return (
    <>
      <Box sx={{ padding: "40px 20px", backgroundColor: "#f5f5f5" }}>
        <Typography
          variant="h4"
          gutterBottom
          align="center"
          sx={{ marginBottom: "40px" }}
        >
          Products for Consumer
        </Typography>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ marginBottom: "20px", fontWeight: "700", fontSize: "22px" }}
        >
          Organic and natural grocery products :
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {productData.map((product, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  maxWidth: 345,
                  boxShadow: 3,
                  aspectRatio: 1,
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2, // Rounded corners for a modern look
                  transition: "transform 0.3s ease", // Hover effect for cards
                  "&:hover": {
                    transform: "scale(1.05)", // Zoom in on hover
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={product.imageUrl}
                  alt={product.title}
                  sx={{
                    objectFit: "cover", // Ensures the image covers the whole area
                    borderTopLeftRadius: 2, // Rounded top-left corners
                    borderTopRightRadius: 2, // Rounded top-right corners
                  }}
                />
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    {product.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box sx={{ padding: "40px 20px", backgroundColor: "#f5f5f5" }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ marginBottom: "20px", fontWeight: "700", fontSize: "22px" }}
        >
          Fresh fruits and Vegetable :
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {productFruitsData.map((product, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  maxWidth: 345,
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2, // Rounded corners for a modern look
                  transition: "transform 0.3s ease", // Hover effect for cards
                  "&:hover": {
                    transform: "scale(1.05)", // Zoom in on hover
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={product.imageUrl}
                  alt={product.title}
                  sx={{
                    objectFit: "cover", // Ensures the image covers the whole area
                    borderTopLeftRadius: 2, // Rounded top-left corners
                    borderTopRightRadius: 2, // Rounded top-right corners
                  }}
                />
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    {product.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default ProductOfCustomers;
